@for (method of paymentOptions; track method) {
  <div
    class="col toggle-payment_tab tab flexed align-items-center"
    (click)="switchPaymentMethod(method)"
    [ngClass]="{
      'checkout-active': activeMethod === method,
      'checkout-inActive': activeMethod !== method,
    }"
  >
    <img style="width: 25px" [src]="getPaymentIcon(method)" />
    <p class="no-margin-b ml-2 tab_">
      {{ method.charAt(0) + method.slice(1).toLowerCase() }}
    </p>
  </div>
}
